module.exports = __webpack_public_path__ + "static/media/Vandercook.9cab1893.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Vandercook.png
// module id = 81
// module chunks = 0